import { useReducer, type ReactNode } from "react";
import { ConfigContext, configReducer } from "./useConfiguration";
import { hydrateConfiguration } from "../lib/persistence";

/**
 * Provides configuration state + dispatch to the tree. Initial state is
 * hydrated lazily from the URL hash / localStorage so a shared link renders
 * the correct state on first paint, with no flash of defaults.
 */
export function ConfigProvider({ children }: { readonly children: ReactNode }) {
  const [config, dispatch] = useReducer(
    configReducer,
    undefined,
    hydrateConfiguration,
  );
  return (
    <ConfigContext value={{ config, dispatch }}>{children}</ConfigContext>
  );
}
